import { isGat } from 'Utils/gattools';

const HashChangeFuncs = [];

export default {
  data() {
    return {
    };
  },
  async created() {
    // 注册第三方注册行数
    await this.initHashChangeFunc();
    window.addEventListener('hashchange', this.onHashChange);
    // window.addEventListener('popstate', this.onPopState);
  },
  methods: {

    // 初始化hashchange事件
    async initHashChangeFunc() {
      this.addHashChangeFunc(this.gatHashChangeFunc);
    },
    onPopState(e) {
      console.log('popstate', e);
    },
    // hashchange事件
    onHashChange(e) {
      for (const f of HashChangeFuncs) {
        f(e);
      }
    },
    // 添加hashchange事件
    addHashChangeFunc(f) {
      HashChangeFuncs.push(f);
    },

    // gat hashchange事件
    async gatHashChangeFunc(e) {
      if (!isGat()) {
        return;
      }

      const oldUrl = new URL(e.oldURL);
      const newUrl = new URL(e.newURL);
      let oldHash = oldUrl.hash.split('?')[0];
      oldHash = oldHash.replace('#', '');
      let newHash = newUrl.hash.split('?')[0];
      newHash = newHash.replace('#', '');

      console.log('hashchange', e);

      console.log(oldHash, '-->', newHash);
    }


  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
    // window.removeEventListener('popstate', this.onPopState);
  }
};
